import {MenuItem} from "./MobileMenu/MenuTypes";
import Link from "next/link";
import {useRef} from "react";
import LabelWithUnderline from "./LabelWithUnderline";
import useArrowKeyNavigation, {
	OrientationMap,
} from "./MobileMenu/useArrowKeyNavigation";
import {navDropdownElementClasses} from "./navElementClasses";
import clsMerge from "@/app/util/clsMerge";

type NavDropdownSubmenuProps = {
	menuItems: MenuItem[];
	classes?: {
		listItems?: string;
	};
};

const NavDropdownSubmenu = ({menuItems, classes}: NavDropdownSubmenuProps) => {
	const firstItemRef = useRef<HTMLAnchorElement | null>(null);

	const handleUpDownEvent = useArrowKeyNavigation({
		preventDefault: true,
		orientation: OrientationMap.VERTICAL,
	});
	return (
		<>
			{menuItems.map((menuItem, index) => {
				if ("menuItems" in menuItem) {
					return null;
				}
				if (menuItem.isExternal) {
					return (
						<a
							role="menuitem"
							href={menuItem.href}
							key={menuItem.id}
							id={menuItem.id}
							className={clsMerge(
								navDropdownElementClasses,
								classes?.listItems
							)}
							onKeyDown={(e) => handleUpDownEvent(e)}
							tabIndex={-1}
						>
							<LabelWithUnderline>{menuItem.label}</LabelWithUnderline>
						</a>
					);
				}
				return (
					<Link
						ref={index === 0 ? firstItemRef : null}
						role="menuitem"
						href={menuItem.href}
						key={menuItem.id}
						id={menuItem.id}
						className={clsMerge(navDropdownElementClasses, classes?.listItems)}
						onKeyDown={(e) => handleUpDownEvent(e)}
						tabIndex={-1}
					>
						<LabelWithUnderline>{menuItem.label}</LabelWithUnderline>
					</Link>
				);
			})}
		</>
	);
};

export default NavDropdownSubmenu;
